import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import pako from 'pako';
export abstract class BaseService {
  constructor(
    private httpClient: HttpClient,
    private baseUrl: string) {
  }

  public put<T>(apiUrl: string, data: any, needDataCompression = false): Observable<T> {
    if (needDataCompression) {
      const httpOptions = this.getCompressedRequestHeaders();
      return this.httpClient.put<T>(this.baseUrl + apiUrl, this.convertToGzipData(data), httpOptions);
    }
    return this.httpClient.put<T>(this.baseUrl + apiUrl, data, this.getHeader());
  }

  public post<T>(apiUrl: string, data?: any, needDataCompression = false, loading = true): Observable<T> {
    if (needDataCompression) {
      const httpOptions = this.getCompressedRequestHeaders();
      return this.httpClient.post<T>(this.baseUrl + apiUrl, this.convertToGzipData(data), httpOptions);
    }
    if (data) {
      return this.postWithData(apiUrl, data, loading);
    } else {
      return this.httpClient.post<T>(this.baseUrl + apiUrl, this.getHeader(loading));
    }
  }

  private convertToGzipData(data: any): any {
    return new Blob([pako.gzip(JSON.stringify(data))]);
  }

  private postWithData<T>(apiUrl: string, data: any, loading: boolean): Observable<T> {
    return this.httpClient.post<T>(this.baseUrl + apiUrl, data, this.getHeader(loading));
  }

  public patch<T>(apiUrl: string, data: any): Observable<T> {
    return this.httpClient.patch<T>(this.baseUrl + apiUrl, data, this.getPatchHeader());
  }

  public delete<T>(apiUrl: string, body?: any): Observable<T> {
    if (body) {
      return this.deleteWithData<T>(apiUrl, body);
    } else {
      return this.httpClient.delete<T>(this.baseUrl + apiUrl, this.getHeader());
    }
  }

  public deleteFromQuery(apiUrl: string, options: any): Observable<any> {
    return this.httpClient.delete(this.baseUrl + apiUrl, options);
  }

  private deleteWithData<T>(apiUrl: string, body: any): Observable<T> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }),
      body
    };

    return this.httpClient.delete<T>(this.baseUrl + apiUrl, options);
  }

  public get<T>(apiUrl: string): Observable<T> {
    return this.httpClient.get<T>(this.baseUrl + apiUrl, this.getHeader());
  }

  public getBlob(apiUrl: string): Observable<Blob> {
    return this.httpClient.get(this.baseUrl + apiUrl, { responseType: 'blob' });
  }

  private getHeader(loading = true) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json'
    });

    if (!loading) {
      headers = headers.append('no-loading', 'true');
    }

    return { headers };
  }

  private getPatchHeader() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json'
      }),
    };
  }

  private getCompressedRequestHeaders() {
    return {
      headers: new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Content-Encoding', 'gzip')
    };
  }
}
